import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  categoryName: string;
  readTime: number;
  publishedAt: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  coverImage,
  category,
  categoryName,
  readTime,
  publishedAt,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block cursor-pointer">
        <div className="aspect-[16/10] overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={title}
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 flex-wrap mb-3">
          <Link
            to={`/category/${category}`}
            className="inline-flex items-center px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-500 flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line text-xs"></i>
            {readTime} 分钟阅读
          </span>
        </div>
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug mb-2 line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3 hidden sm:block">
          {excerpt}
        </p>
        <span className="text-xs text-foreground-400">{publishedAt}</span>
      </div>
    </article>
  );
}